import React from "react";
import { motion } from "framer-motion";
import { Trophy, Gift, GraduationCap, Mic, BookOpen, UserCheck } from "lucide-react";

const features = [
  {
    id: 1,
    icon: <Trophy className="w-8 h-8 text-[#9E1C22]" />,
    title: "GRAND RECOGNITION",
    description: "Earn Medals, Trophies, & Ranker's Certificates For Top Achievers",
  },
  {
    id: 2,
    icon: <Gift className="w-8 h-8 text-[#9E1C22]" />,
    title: "EXCLUSIVE GOODIES",
    description: "Take Home Special PW Merchandise, Certificates, And Surprise Gifts.",
  },
  {
    id: 3,
    icon: <GraduationCap className="w-8 h-8 text-[#9E1C22]" />,
    title: "ACHIEVERS SCHOLARSHIP",
    description: "Get Scholarships Of Up To 100% To Support Your Exam Preparation.",
  },
  {
    id: 4,
    icon: <Mic className="w-8 h-8 text-[#9E1C22]" />,
    title: "PODCAST WITH FACULTY",
    description: "Exclusive Interactive Session With Your Favourite Mentors.",
  },
  {
    id: 5,
    icon: <BookOpen className="w-8 h-8 text-[#9E1C22]" />,
    title: "PRACTICAL GUIDANCE",
    description: "Short Alumni Insight + Faculty Q&A To Guide Next-step Exam Preparation.",
  },
  {
    id: 6,
    icon: <UserCheck className="w-8 h-8 text-[#9E1C22]" />,
    title: "PERSONAL MENTORING",
    description: "On-site Counselling & Next-step Guidance For Jee | NEET | Foundation Aspirants.",
  },
];

const WhyAttend: React.FC = () => {
  return (
    // Background color matched to the light cream/peach in the image
    <section className="relative bg-[#FFF6EC] py-16 px-4 md:px-12 lg:px-20 overflow-hidden border-y-4 border-[#eecda3]">
      
      {/* Decorative Border Frame Effect (Optional, adds to the 'Certificate' feel) */}
      <div className="absolute inset-4 border-2 border-[#D4A76A] rounded-3xl pointer-events-none opacity-50"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        
        {/* --- Header --- */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-[#A02422] uppercase tracking-tight drop-shadow-sm">
            Why Attend?
          </h2>
        </div>

        {/* --- Grid Layout --- */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10">
          {features.map((feature, index) => (
            <motion.div
              key={feature.id}
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="flex items-center group"
            >
              {/* --- Icon Box (Left) --- */}
              {/* White rounded square with shadow, placed on top */}
              <div className="z-20 flex-shrink-0 w-20 h-20 bg-white rounded-2xl shadow-[0_8px_20px_rgba(0,0,0,0.15)] flex items-center justify-center border-2 border-[#FFE4C4] group-hover:scale-110 transition-transform duration-300">
                {feature.icon}
              </div>

              {/* --- Content Bar (Right) --- */}
              {/* Maroon gradient bar extending to the right */}
              <div className="-ml-10 pl-14 pr-6 py-5 flex-grow bg-gradient-to-r from-[#69080E] to-[#9E1C22] rounded-r-2xl rounded-l-lg shadow-lg text-left h-auto min-h-[100px] flex flex-col justify-center relative overflow-hidden">
                
                {/* Shine Effect on Hover */}
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:animate-[shimmer_1s_infinite]"></div>

                <h3 className="text-[#FFD700] font-bold text-lg uppercase mb-1 tracking-wide">
                  {feature.title}
                </h3>
                <p className="text-white text-xs md:text-sm font-medium leading-relaxed opacity-90">
                  {feature.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyAttend;